<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i>
        <strong>Monitoring des tâches planifiées</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <v-client-table class="mt-4" :columns="columns" :data="items" :options="options">
            <div slot="date_start" slot-scope="props" class="slot-date">
                {{ getFormattedDateTime(props.row.date_start) }}
            </div>
            <div slot="date_stop" slot-scope="props" class="slot-date">
                {{ getFormattedDateTime(props.row.date_stop) }}
            </div>
            <div slot="commentaire" slot-scope="props" class="" v-html="showRapport(props.row)">
              <!-- <i class="fa fa-list clickable" @click="showRapport(props.row)" v-if="hasRapport(props.row)"></i> -->
            </div>
          </v-client-table>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import moment from 'moment';
  import { formatDateTime } from "@/utils/communHelper";
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "Cron",
    data() {
      return {
        dataIsReady: false,
        items: [],
        columns: ['libelle', 'date_start', 'date_stop', 'periodicity', 'statut', 'commentaire'],
        options: {
          headings: {
            libelle: 'Tâche planifiée',
            date_start: 'Dernière execution',
            date_stop: 'Date de fin',
            periodicity: 'Périodicité',
            statut: 'Statut',
            commentaire: 'Information complémentaire',
          },
          rowClassCallback: function(row) {
            if(row.statut === 'OK'){
              return 'bg-success';
            }else if(row.statut === 'KO'){
              return 'bg-danger';
            }else if(row.statut === 'En cours'){
              return 'bg-primary';
            }else{
             return 'bg-secondary';
            }

          },
          perPage: 50,
          filterable: false,
          sortable: ['statut','date_start','date_stop'],
          perPageValues: [50,100],
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all();
    },
    methods: {
      all() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/administration/monitoring-list")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.data;
            this.dataIsReady = true;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      getFormattedDateTime(textDate) {
        if(textDate !== null && textDate !== ''){
          return formatDateTime(textDate, '/');
        }
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      hasRapport(cron) {
        // if (!isEmpty(cron.commentaire)) {
        //   console.log('cron.libelle_technique',cron.libelle_technique)
        // }
        console.log(cron.libelle_technique, cron.commentaire)
        return cron.libelle_technique === 'module_prev_envoi_mutex' && !isEmpty(cron.commentaire)
      },
      showRapport(cron) {
        if (cron.libelle_technique === 'module_prev_envoi_mutex' && !isEmpty(cron.commentaire)) {
          let json = JSON.parse(cron.commentaire);
          let response = '<ul>';
          for (let error of json) {
            response += '<li>' + error + '</li>';
          }
          response += '</ul>';

          return response;
        } else {
          return cron.commentaire;
        }
      },
    }
  }
</script>
